<template>
  <div v-if="!isLoading">
    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
  <div v-else>
    <v-loader class="mt-2"></v-loader>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import {mapActions, mapState} from "pinia";
import {DashboardRangeStore} from "@/scripts/store/dashboard_range.store";
import {useAnalytics} from "@/scripts/store/analytics";
import VLoader from "@/scripts/components/app/common/VLoader.vue";

export default {
  components: {
    VLoader,
    apexchart: VueApexCharts
  },

  props: {
    codeIdentifier: {
      default: null
    }
  },

  async mounted() {
    this.fillEmpty()
    await this.refreshSeries()

    DashboardRangeStore().$subscribe((mutation, state) => {
      this.refreshSeries()
    })
  },

  data() {
    return {
      isLoading: false,
      series: [{
        name: "Все",
        data: []
      }, {
        name: "Уникальные",
        data: []
      }],
      chartOptions: {
        chart: {
          type: "line",
          zoom: {
            enabled: !1
          },
        },
        stroke: {
          curve: "smooth"
        },
        colors: ["#5972ff", "#00E396"],
        title: {
          text: "Статистика сканирований",
          align: "left",
          margin: 0,
          offsetX: -10,
          style: {
            fontSize: "17px",
            fontWeight: "500",
            fontFamily: "Inter"
          }
        },
        legend: {
          position: "bottom",
          horizontalAlign: "left"
        },
        xaxis: {
          type: "datetime",
          // min: this.currentRange.from.getTime(),
          // max: this.currentRange.to.getTime()
        },
        yaxis: [{
          labels: {
            formatter: function (A) {
              return void 0 !== A ? A.toFixed(0) : 0
            }
          }
        }],
        tooltip: {
          x: {
            format: "dd MMM yyyy"
          }
        }
      }
    }
  },

  computed: {
    ...mapState(DashboardRangeStore, ["currentRange"]),
    ...mapState(useAnalytics, ["scans", "uniqScans"]),
  },

  methods: {
    ...mapActions(useAnalytics, ["loadScans", "loadUniqScans"]),
    async refreshSeries() {
      this.isLoading = true

      await Promise.all([
        this.loadScans(this.currentRange.from, this.currentRange.to, this.codeIdentifier),
        this.loadUniqScans(this.currentRange.from, this.currentRange.to, this.codeIdentifier),
      ])

      this.fillEmpty()

      for (const e of this.scans) {
        for (const t of this.series[0].data) {
          if (this.compareDatesByDay(new Date(e.x), new Date(t[0])) === 0) {
            t[1] = e.y;
            break
          }
        }
      }

      for (const e of this.uniqScans) {
        for (const t of this.series[1].data) {
          if (this.compareDatesByDay(new Date(e.x), new Date(t[0])) === 0) {
            t[1] = e.y;
            break
          }
        }
      }

      this.isLoading = false
    },

    compareDatesByDay(date1, date2) {
      const day1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
      const day2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

      if (day1 < day2) {
        return -1;
      } else if (day1 > day2) {
        return 1;
      } else {
        return 0;
      }
    },

    fillEmpty() {
      this.series[0].data = [];
      this.series[1].data = [];

      const dates = this.getDatesBetween(
          new Date(this.currentRange.from),
          new Date(this.currentRange.to)
      )
      for (const t of dates) {
        this.series[0].data.push([t + " GMT", 0])
        this.series[1].data.push([t + " GMT", 0])
      }
    },

    getDatesBetween(startDate, endDate) {
      const dates = [];
      const currentDate = startDate;

      while (currentDate.setHours(0,0,0) <= endDate.setHours(0,0,0)) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dates;
    },
  }
}

</script>
